import DelBox from "../comps/DelBox";
import NewSupplier from "../models/NewSupplier";
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import DataTable from 'react-data-table-component';
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";


function Suppliers() {
  const [formData, setFormData] = useState({
    l1: [],
    cat_type: 'supplier',
    search_key: '',
    page_no: 0,
    alertMsg: '',
    alertMsgTyp: '',
    isAlert: false,
  });
  const [isAdmin, setIsAdmin] = useState(false);
  const [ldata, setLdata] = useState(null);
  const [editItem, setEditItem] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [supplierPurchases, setSupplierPurchases] = useState([]);
  const [selectedPurchase, setSelectedPurchase] = useState(null);
  const [transactions, setTransactions] = useState([]);
// ✅ Track current page rows for footer totals
const [currentPage, setCurrentPage] = useState(1);
const [rowsPerPage, setRowsPerPage] = useState(10);

  // ✅ Direct Supplier Payment
const [showDirectPayModal, setShowDirectPayModal] = useState(false);
const [directPaySupplier, setDirectPaySupplier] = useState(null);
const [directPayData, setDirectPayData] = useState({
  amount: '',
  payment_type: 'cash',
  payment_ref: '',
  remarks: 'Direct supplier payment'
});
const openDirectPayModal = (supplier) => {
  setDirectPaySupplier(supplier);
  setDirectPayData({
    amount: '',
    payment_type: 'cash',
    payment_ref: '',
    remarks: 'Direct supplier payment'
  });
  setShowDirectPayModal(true);
};

  const [paymentData, setPaymentData] = useState({
    amount: '',
    payment_type: 'cash',
    payment_ref: '',
    remarks: ''
  });
  const [filterText, setFilterText] = useState('');
  
  // Modal states
  const [showPurchasesModal, setShowPurchasesModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showTransactionsModal, setShowTransactionsModal] = useState(false);
  const handleDirectPay = async (e) => {
    e.preventDefault();
  
    if (!directPaySupplier?.user_id) {
      toast.error("Supplier not selected");
      return;
    }
  
    try {
      const fd = new FormData();
      fd.append('supplier_id', directPaySupplier.user_id);
      fd.append('amount', directPayData.amount);
      fd.append('payment_type', directPayData.payment_type);
      fd.append('payment_ref', directPayData.payment_ref);
      fd.append('remarks', directPayData.remarks);
      fd.append('user_id', ldata.user_id);
  
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.createSupplierDirectPaymentUrl,
        fd
      );
  
      if (res.data.status) {
        toast.success("Direct payment applied successfully");
        setShowDirectPayModal(false);
        initData(); // refresh supplier summary
      } else {
        toast.error(res.data.message);
      }
  
    } catch (err) {
      toast.error(err.response?.data?.message || err.message);
    }
  };
  const exportPurchasesPDF = () => {
    if (!supplierPurchases || supplierPurchases.length === 0) {
      toast.error("No purchases to export");
      return;
    }
  
    const doc = new jsPDF();
  
    doc.setFontSize(16);
    doc.text("Supplier Purchases Report", 14, 15);
  
    doc.setFontSize(12);
    doc.text(`Supplier: ${selectedSupplier?.fname}`, 14, 25);
    doc.text(`Date: ${new Date().toLocaleDateString("en-IN")}`, 150, 25);
  
    const tableColumn = [
      "Sl No",
      "Invoice No",
      "Date",
      "Total Amount",
      "Paid Amount",
      "Due Amount",
      "Status"
    ];
  
    const tableRows = supplierPurchases.map((item, index) => [
      index + 1,
      item.purchase_invoice || "-",
      new Date(item.purchase_date).toLocaleDateString("en-IN"),
      `${parseFloat(item.purchase_total || 0).toFixed(2)}`,
      `${parseFloat(item.total_paid_amount || item.purchase_paid || 0).toFixed(2)}`,
      `${parseFloat(item.remaining_due || item.purchase_due || 0).toFixed(2)}`,
      item.payment_status
    ]);
  
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 35,
    });
  
    doc.save(`Purchases_${selectedSupplier?.fname}.pdf`);
  };
   
  
  // ✅ Custom styles for DataTable
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: '#f3f6f9',
        fontWeight: 'bold',
        fontSize: '14px',
        color: '#000',
        textTransform: 'uppercase',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
        '&:hover': {
          backgroundColor: '#f8f9fa',
          cursor: 'pointer',
        },
      },
    },
  };

  // ✅ Supplier Table Columns
  const supplierColumns = [
    {
      name: 'Sr. No.',
      selector: (row, index) => index + 1,
      sortable: false,
      width: '80px',
    },
    {
      name: 'Name',
      selector: row => row.fname,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Contact',
      selector: row => row.mobile,
      sortable: true,
    },
    {
      name: 'Address',
      selector: row => `${row.address_line1 || ''}, ${row.address_line2 || ''}, ${row.city || ''}, ${row.pincode || ''}`,
      sortable: true,
      wrap: true,
      minWidth: '250px',
    },
    {
      name: 'Total Amount',
      selector: row => `₹${parseFloat(row.total_purchase_amount || 0).toFixed(2)}`,
      sortable: true,
      right: true,
    },
    {
      name: 'Paid Amount',
      selector: row => `₹${parseFloat(row.total_paid_amount || 0).toFixed(2)}`,
      sortable: true,
      right: true,
    },
    {
      name: 'Due Amount',
      cell: row => (
        <div className="d-flex align-items-center gap-2">
          <span>₹{parseFloat(row.total_due_amount || 0).toFixed(2)}</span>
          {parseFloat(row.total_due_amount || 0) > 0 && (
            <button
              className="btn btn-sm btn-success"
              onClick={() => loadSupplierPurchases(row)}
              title="View & Pay"
            >
              <i className="ri-money-dollar-circle-line"> Invoice Pay</i>
            </button>
          )}
        </div>
      ),
      sortable: true,
      right: true,
      minWidth: '220px',
    },
    {
      name: 'Action',
      cell: row => (
        <div className="d-flex gap-2">
          <button
        className="btn btn-sm btn-success"
        onClick={() => openDirectPayModal(row)}
      >
        <i className="ri-wallet-3-line"></i> Direct Pay
      </button>
          <button
            className="btn btn-sm btn-info"
            onClick={() => loadSupplierPurchases(row)}
            title="View Purchases"
          >
            <i className="ri-file-list-line"></i>
          </button>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={(e) => {
              e.preventDefault();
              setEditItem(row);
              document.getElementById("addbt453").click();
            }}
          >
            <i className="ri-pencil-fill"></i>
          </button>
          <button
            type="button"
            disabled={!isAdmin}
            style={{
              opacity: !isAdmin ? 0.5 : 1,
              pointerEvents: !isAdmin ? "none" : "auto"
            }}
            className="btn btn-sm btn-danger"
            onClick={(e) => {
              e.preventDefault();
              delItem(row);
            }}
          >
            <i className="ri-delete-bin-5-fill"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      minWidth: '280px',
    },
  ];

  // ✅ Purchases Table Columns
  const purchasesColumns = [
    {
      name: 'Sl. No.',
      selector: (row, index) => index + 1,
      sortable: false,
      width: '80px',
    },
    {
      name: 'Invoice No',
      selector: row => row.purchase_invoice || '-',
      sortable: true,
    },
    {
      name: 'Date',
      selector: row => new Date(row.purchase_date).toLocaleDateString('en-IN'),
      sortable: true,
    },
    {
      name: 'Total Amount',
      selector: row => `₹${parseFloat(row.purchase_total || 0).toFixed(2)}`,
      sortable: true,
      right: true,
    },
    {
      name: 'Paid Amount',
      selector: row => `₹${parseFloat(row.total_paid_amount || row.purchase_paid || 0).toFixed(2)}`,
      sortable: true,
      right: true,
    },
    {
      name: 'Due Amount',
      selector: row => `₹${parseFloat(row.remaining_due || row.purchase_due || 0).toFixed(2)}`,
      sortable: true,
      right: true,
    },
    {
      name: 'Status',
      cell: row => getPaymentStatusBadge(row.payment_status),
      sortable: true,
    },
    {
      name: 'Action',
      cell: row => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm btn-info"
            onClick={() => loadPurchaseTransactions(row)}
            title="View Transactions"
          >
            <i className="ri-eye-line">View Transaction</i>
          </button>
          {parseFloat(row.remaining_due || row.purchase_due || 0) > 0 && (
            <button
              className="btn btn-sm btn-success"
              onClick={() => openPaymentModal(row)}
              title="Make Payment"
            >
              <i className="ri-money-dollar-circle-line"> Pay</i>
            </button>
          )}
        </div>
      ),
      ignoreRowClick: true,
      minWidth: '270px',
    },
  ];

  // ✅ Transactions Table Columns
  const transactionsColumns = [
    {
      name: 'Sl. No.',
      selector: (row, index) => index + 1,
      sortable: false,
      width: '80px',
    },
    {
      name: 'Date',
      selector: row => new Date(row.purchase_trans_date).toLocaleDateString('en-IN'),
      sortable: true,
    },
    {
      name: 'Payment Type',
      cell: row => (
        <span className="badge bg-info">
          {row.purchase_trans_payment_type.toUpperCase()}
        </span>
      ),
      sortable: true,
    },
    {
      name: 'Paid Amount',
      selector: row => `₹${parseFloat(row.purchase_trans_amount).toFixed(2)}`,
      sortable: true,
      right: true,
    },
    {
      name: 'Reference',
      selector: row => row.purchase_trans_payment_ref || '-',
      sortable: true,
    },
    {
      name: 'Remarks',
      selector: row => row.purchase_trans_remarks || '-',
      sortable: true,
      wrap: true,
    },
    {
      name: 'Action',
      cell: row => (
        isAdmin && (
          <button
            className="btn btn-sm btn-danger"
            onClick={() => deleteTransaction(row.purchase_trans_id)}
            title="Delete Transaction"
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        )
      ),
      ignoreRowClick: true,
    },
  ];

  // ✅ Initialize Data with Summary
  const initData = async () => {
    const storedData = sessionStorage.getItem("ldata");
    const userData = JSON.parse(sessionStorage.getItem("ldata"));
    const roleId = userData?.role_id;
    
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }

    if (storedData) {
      try {
        console.log('📡 Fetching suppliers from:', AppConst.BASE_URL + AppConst.getSuppliersWithDueUrl);
        
        const response = await axios.post(
          AppConst.BASE_URL + AppConst.getSuppliersWithDueUrl,
          {},
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
        
        console.log('✅ Suppliers response:', response.data);
        
        if (response.data.status) {
          var records = response.data.records;
          if (records != null && records != undefined) {
            setFormData(prev => ({
              ...prev,
              l1: records
            }));
          }
        } else {
          toast.error(response.data.message || "Failed to load suppliers");
        }
      } catch (error) {
        console.error("❌ Error loading suppliers:", error);
        console.error("Error details:", error.response?.data);
        toast.error("Error loading suppliers: " + (error.response?.data?.message || error.message));
      }
    }
  };
  const totalAmount = supplierPurchases.reduce(
    (sum, item) => sum + parseFloat(item.purchase_total || 0),
    0
  );
  
  const paidAmount = supplierPurchases.reduce(
    (sum, item) => sum + parseFloat(item.total_paid_amount || item.purchase_paid || 0),
    0
  );
  
  const dueAmount = supplierPurchases.reduce(
    (sum, item) => sum + parseFloat(item.remaining_due || item.purchase_due || 0),
    0
  );
  // ✅ Load Supplier Purchases
  const loadSupplierPurchases = async (supplier) => {
    try {
      console.log('📡 Loading purchases for supplier:', supplier.user_id);
      console.log('API URL:', AppConst.BASE_URL + AppConst.getSupplierPurchasesUrl);
      
      const fd = new FormData();
      fd.append('supplier_id', supplier.user_id);

      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getSupplierPurchasesUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      console.log('✅ Purchases response:', response.data);

      if (response.data.status) {
        setSelectedSupplier(supplier);
        setSupplierPurchases(response.data.records || []);
        setShowPurchasesModal(true); // ✅ Show modal using state
      } else {
        toast.error(response.data.message || "Failed to load purchases");
      }
    } catch (error) {
      console.error("❌ Error loading purchases:", error);
      console.error("Error response:", error.response?.data);
      
      // Show detailed error
      Swal.fire({
        icon: 'error',
        title: 'Error Loading Purchases',
        html: `
          <p><strong>Supplier ID:</strong> ${supplier.user_id}</p>
          <p><strong>Error:</strong> ${error.response?.data?.message || error.message}</p>
          <p><strong>API URL:</strong> ${AppConst.BASE_URL + AppConst.getSupplierPurchasesUrl}</p>
          <hr>
          <p class="text-muted">Please check:</p>
          <ul class="text-start text-muted">
            <li>Backend API is implemented</li>
            <li>Route is configured correctly</li>
            <li>Database tables exist</li>
          </ul>
        `,
        confirmButtonText: 'OK'
      });
      
      toast.error("Error loading purchases. Check console for details.");
    }
  };

  // ✅ Load Purchase Transactions
  const loadPurchaseTransactions = async (purchase) => {
    try {
      console.log('📡 Loading transactions for purchase:', purchase.purchase_id);
      
      const fd = new FormData();
      fd.append('purchase_id', purchase.purchase_id);

      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getPurchaseTransactionsUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      console.log('✅ Transactions response:', response.data);

      if (response.data.status) {
        setSelectedPurchase({
          ...purchase,
          total_paid: response.data.total_paid,
          remaining_due: response.data.remaining_due
        });
        setTransactions(response.data.transactions || []);
        setShowPurchasesModal(false); // Close purchases modal
        setShowTransactionsModal(true); // Show transactions modal
      } else {
        toast.error(response.data.message || "Failed to load transactions");
      }
    } catch (error) {
      console.error("❌ Error loading transactions:", error);
      console.error("Error response:", error.response?.data);
      toast.error("Error loading transactions: " + (error.response?.data?.message || error.message));
    }
  };

  // ✅ Open Payment Modal
  const openPaymentModal = (purchase) => {
    setSelectedPurchase(purchase);
    setPaymentData({
      amount: purchase.remaining_due || purchase.purchase_due,
      payment_type: 'cash',
      payment_ref: '',
      remarks: ''
    });
    setShowPaymentModal(true);
  };

  // ✅ Handle Payment
  const handlePayment = async (e) => {
    e.preventDefault();

    if (!paymentData.amount || parseFloat(paymentData.amount) <= 0) {
      toast.error("Please enter valid amount");
      return;
    }

    try {
      const fd = new FormData();
      fd.append('purchase_id', selectedPurchase.purchase_id);
      fd.append('amount', paymentData.amount);
      fd.append('payment_type', paymentData.payment_type);
      fd.append('payment_ref', paymentData.payment_ref);
      fd.append('remarks', paymentData.remarks);
      fd.append('user_id', ldata.user_id);

      const response = await axios.post(
        AppConst.BASE_URL + AppConst.createPurchaseTransactionUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.status) {
        toast.success("Payment recorded successfully");
        setShowPaymentModal(false); // Close modal
        
        // Reload data
        loadSupplierPurchases(selectedSupplier);
        initData();
      } else {
        toast.error(response.data.success || "Failed to record payment");
      }
    } catch (error) {
      console.error("Payment error:", error);
      toast.error("Error recording payment: " + (error.response?.data?.message || error.message));
    }
  };

  // ✅ Delete Transaction (Admin Only)
  const deleteTransaction = async (transId) => {
    if (!isAdmin) {
      toast.error("Only admin can delete transactions");
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to delete this transaction?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const fd = new FormData();
          fd.append('trans_id', transId);

          const response = await axios.post(
            AppConst.BASE_URL + AppConst.deletePurchaseTransactionUrl,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );

          if (response.data.status) {
            toast.success("Transaction deleted successfully");
            loadPurchaseTransactions(selectedPurchase);
            initData();
          } else {
            toast.error(response.data.message || "Failed to delete transaction");
          }
        } catch (error) {
          console.error("Delete error:", error);
          toast.error("Error deleting transaction");
        }
      }
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const delItem = async (editItem) => {
    if (!isAdmin) {
      toast.error("Only admin can delete suppliers");
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to delete this supplier?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const fd = new FormData();
        fd.append('user_id', editItem.user_id + "");
        try {
          const response = await axios.post(AppConst.BASE_URL + AppConst.delUserUrl, fd, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          if (response.data.status) {
            toast.success("Supplier deleted successfully");
            initData();
          }
        } catch (error) {
          toast.error("Error deleting supplier");
        }
      }
    });
  };

  const handleAddDepart = () => {
    formData.page_no = 0;
    initData();
  };

  const getPaymentStatusBadge = (status) => {
    switch (status) {
      case 'paid':
        return <span className="badge bg-success">Paid</span>;
      case 'partial_paid':
        return <span className="badge bg-warning">Partial Paid</span>;
      case 'not_paid':
        return <span className="badge bg-danger">Not Paid</span>;
      default:
        return <span className="badge bg-secondary">Unknown</span>;
    }
  };

  // ✅ Filter data
  const filteredSuppliers = formData.l1.filter(
    item => item.fname && item.fname.toLowerCase().includes(filterText.toLowerCase())
  );

  useEffect(() => {
    console.log('🚀 Component mounted');
    console.log('📍 AppConst BASE_URL:', AppConst.BASE_URL);
    
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      console.log('👤 User data:', parsed);
      initData();
    } else {
      console.warn('⚠️ No user data in sessionStorage');
    }

    return () => {
      console.log('Component unmounted');
    };
  }, []);


// Purchase Summary Totals
const currentPageSuppliers = filteredSuppliers.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);

const supplierSummary = currentPageSuppliers.reduce(
  (acc, item) => {
    acc.total += parseFloat(item.total_purchase_amount || 0);
    acc.paid  += parseFloat(item.total_paid_amount || 0);
    acc.due   += parseFloat(item.total_due_amount || 0);
    return acc;
  },
  { total: 0, paid: 0, due: 0 }
);



  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="row align-items-center gy-3 p-3">
                <div className="col-sm">
                  <h5 className="card-title mb-0">Suppliers Payment Management</h5>
                </div>
                <div className="col-sm-auto">
                  <div className="d-flex gap-1 flex-wrap">
                    <button
                      id="addbt453"
                      style={{ display: "none" }}
                      type="button"
                      className="btn btn-success add-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#showModal"
                    />
                    <button
                      type="button"
                      className="btn btn-success add-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        setEditItem(null);
                        document.getElementById("addbt453").click();
                      }}
                    >
                      <i className="ri-add-line align-bottom me-1"></i> Add Supplier
                    </button>
                  </div>
                </div>
              </div>

              <br />
              <div className="card-body pt-0">
                {/* ✅ React DataTable */}
                <DataTable
  columns={supplierColumns}
  data={filteredSuppliers}
  pagination
  paginationPerPage={rowsPerPage}
  paginationRowsPerPageOptions={[10, 20, 30, 50]}
  onChangePage={(page) => setCurrentPage(page)}
  onChangeRowsPerPage={(newPerPage, page) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(page);
  }}
  highlightOnHover
  striped
  responsive
  customStyles={customStyles}
  subHeader
  subHeaderAlign="right"
  subHeaderComponent={
    <div style={{ width: "300px", maxWidth: "100%" }}>
      <input
        type="text"
        placeholder="Search suppliers..."
        className="form-control"
        value={filterText}
        onChange={(e) => {
          setFilterText(e.target.value);
          setCurrentPage(1); // reset to page 1 on search
        }}
      />
    </div>
  }
  noDataComponent={
    <div className="text-center p-4">
      <p className="text-muted">No suppliers found</p>
    </div>
  }
/>

    
                
                <div className="modal-footer flex-column">

{/* Summary Footer */}
<div className="w-100 mb-3">
  <div className="row text-center">
    <div className="col-md-4">
      <div className="alert alert-primary mb-0">
        <strong>Total Amount</strong><br />
        ₹{supplierSummary.total.toFixed(2)}
      </div>
    </div>

    <div className="col-md-4">
      <div className="alert alert-success mb-0">
        <strong>Paid Amount</strong><br />
        ₹{supplierSummary.paid.toFixed(2)}
      </div>
    </div>

    <div className="col-md-4">
      <div className="alert alert-danger mb-0">
        <strong>Due Amount</strong><br />
        ₹{supplierSummary.due.toFixed(2)}
      </div>
    </div>
  </div>
</div>


{/* Buttons */}
<div className="d-flex justify-content-between w-100">
  <button
    type="button"
    className="btn btn-danger"
    onClick={exportPurchasesPDF}
  >
    <i className="ri-file-pdf-line me-1"></i> Export PDF
  </button>

  <button
    type="button"
    className="btn btn-secondary"
    onClick={() => setShowPurchasesModal(false)}
  >
    Close
  </button>
</div>

</div>


                <NewSupplier item={editItem} onAddDepart={handleAddDepart} />
                <DelBox />
              </div>
            </div>
          </div>
        </div>
      </div>



      {showDirectPayModal && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog">
      <div className="modal-content">

        <form onSubmit={handleDirectPay}>
          <div className="modal-header">
            <h5 className="modal-title">
              Direct Payment – {directPaySupplier?.fname}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setShowDirectPayModal(false)}
            />
          </div>

          <div className="modal-body">

            <div className="mb-2">
              <label className="form-label">Total Due</label>
              <input
                className="form-control"
                value={`₹${parseFloat(directPaySupplier?.total_due_amount || 0).toFixed(2)}`}
                readOnly
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Pay Amount</label>
              <input
                type="number"
                className="form-control"
                value={directPayData.amount}
                onChange={(e) =>
                  setDirectPayData({ ...directPayData, amount: e.target.value })
                }
                max={directPaySupplier?.total_due_amount}
                required
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Payment Type</label>
              <select
                className="form-control"
                value={directPayData.payment_type}
                onChange={(e) =>
                  setDirectPayData({ ...directPayData, payment_type: e.target.value })
                }
              >
                <option value="cash">Cash</option>
                <option value="upi">UPI</option>
                <option value="card">Card</option>
                <option value="online">Online</option>
              </select>
            </div>

            <div className="mb-2">
              <label className="form-label">Reference</label>
              <input
                className="form-control"
                value={directPayData.payment_ref}
                onChange={(e) =>
                  setDirectPayData({ ...directPayData, payment_ref: e.target.value })
                }
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Remarks</label>
              <textarea
                className="form-control"
                rows="2"
                value={directPayData.remarks}
                onChange={(e) =>
                  setDirectPayData({ ...directPayData, remarks: e.target.value })
                }
              />
            </div>

          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowDirectPayModal(false)}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-success">
              <i className="ri-check-line"></i> Pay
            </button>
          </div>

        </form>

      </div>
    </div>
  </div>
)}

      {/* ✅ Supplier Purchases Modal - Controlled by State */}
      {showPurchasesModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Purchases - {selectedSupplier?.fname}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowPurchasesModal(false)}></button>
              </div>
              <div className="modal-body">
                {/* ✅ Purchases DataTable */}
                <DataTable
                  columns={purchasesColumns}
                  data={supplierPurchases}
                  pagination
                  paginationPerPage={10}
                  highlightOnHover
                  striped
                  responsive
                  customStyles={customStyles}
                  noDataComponent={
                    <div className="text-center p-4">
                      <p className="text-muted">No purchases found for this supplier</p>
                    </div>
                  }
                />
              </div>
              <div className="modal-footer d-flex justify-content-between">
  <button
    type="button"
    className="btn btn-danger"
    onClick={exportPurchasesPDF}
  >
    <i className="ri-file-pdf-line me-1"></i> Export PDF
  </button>

  <button
    type="button"
    className="btn btn-secondary"
    onClick={() => setShowPurchasesModal(false)}
  >
    Close
  </button>
</div>

            </div>
          </div>
        </div>
      )}

      {/* ✅ Payment Modal - Controlled by State */}
      {showPaymentModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handlePayment}>
                <div className="modal-header">
                  <h5 className="modal-title">Make Payment</h5>
                  <button type="button" className="btn-close" onClick={() => setShowPaymentModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Invoice No</label>
                    <input
                      type="text"
                      className="form-control"
                      value={selectedPurchase?.purchase_invoice || ''}
                      readOnly
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Due Amount</label>
                    <input
                      type="text"
                      className="form-control"
                      value={`₹${parseFloat(selectedPurchase?.remaining_due || selectedPurchase?.purchase_due || 0).toFixed(2)}`}
                      readOnly
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Payment Amount <span className="text-danger">*</span></label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      value={paymentData.amount}
                      onChange={(e) => setPaymentData({...paymentData, amount: e.target.value})}
                      max={selectedPurchase?.remaining_due || selectedPurchase?.purchase_due}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Payment Type <span className="text-danger">*</span></label>
                    <select
                      className="form-control"
                      value={paymentData.payment_type}
                      onChange={(e) => setPaymentData({...paymentData, payment_type: e.target.value})}
                      required
                    >
                      <option value="cash">Cash</option>
                      <option value="online">Online</option>
                      <option value="card">Card</option>
                      <option value="cheque">Cheque</option>
                      <option value="upi">UPI</option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Payment Reference</label>
                    <input
                      type="text"
                      className="form-control"
                      value={paymentData.payment_ref}
                      onChange={(e) => setPaymentData({...paymentData, payment_ref: e.target.value})}
                      placeholder="Transaction ID / Cheque No"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Remarks</label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={paymentData.remarks}
                      onChange={(e) => setPaymentData({...paymentData, remarks: e.target.value})}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowPaymentModal(false)}>
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-success">
                    <i className="ri-check-line me-1"></i> Submit Payment
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Transactions Modal - Controlled by State */}
      {showTransactionsModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Payment Transactions - Invoice: {selectedPurchase?.purchase_invoice}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowTransactionsModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-body">
                        <p className="text-muted mb-1">Total Amount</p>
                        <h5>₹{parseFloat(selectedPurchase?.purchase_total || 0).toFixed(2)}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-body">
                        <p className="text-muted mb-1">Paid Amount</p>
                        <h5 className="text-success">₹{parseFloat(selectedPurchase?.total_paid || 0).toFixed(2)}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card">
                      <div className="card-body">
                        <p className="text-muted mb-1">Due Amount</p>
                        <h5 className="text-danger">₹{parseFloat(selectedPurchase?.remaining_due || 0).toFixed(2)}</h5>
                      </div>
                    </div>
                  </div>
                </div>

                <h6>Transaction List</h6>
                {/* ✅ Transactions DataTable */}
                <DataTable
                  columns={transactionsColumns}
                  data={transactions}
                  pagination
                  paginationPerPage={10}
                  highlightOnHover
                  striped
                  responsive
                  customStyles={customStyles}
                  noDataComponent={
                    <div className="text-center p-4">
                      <p className="text-muted">No transactions found. Make a payment to create transaction history.</p>
                    </div>
                  }
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowTransactionsModal(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Suppliers;